var map = {
	"./round-1.png": 72969,
	"./round-2.png": 94927,
	"./round-3.png": 86014,
	"./round-4.png": 36688,
	"./round-5.png": 96169,
	"./round-6.png": 4110,
	"./round-7.png": 49720,
	"./round-8.png": 80645
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98966;